module.exports = __webpack_public_path__ + "img/75_21.8191da38.png";